import { render } from "./TableDialog.vue?vue&type=template&id=3f058d5c"
import script from "./TableDialog.vue?vue&type=script&lang=js"
export * from "./TableDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__